import { CircularProgress, Fade, Typography } from '@mui/material';
import { getColors } from '../../theme';

const colors = getColors();
const { loader, loaderBlack, colorShades, primary } = colors;
function Loader({
  style,
  variant,
  size,
  hideText,
  text,
  overlay,
  absolute = false,
  backgroundColor = loader.transparent,
}) {
  const ostyle = {
    justifyContent: 'center',
    position: 'fixed',
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    top: 0,
    alignItems: 'center',
    right: 0,
    bottom: 0,
    zIndex: 9999999999,
    backgroundColor,
    ...style,
  };

  const absoluteStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: backgroundColor || loaderBlack,
    zIndex: '1',
  };

  const overlayStyle = overlay ? ostyle : {};
  const styles = absolute ? absoluteStyle : overlayStyle;
  return (
    <Fade in style={{ display: 'flex' }}>
      <div style={styles}>
        <CircularProgress variant={variant} size={size} sx={{ color: primary.main }} />
        <Typography variant="h4" fontFamily="fontMedium" mt={2}>
          {!hideText && text}
        </Typography>
      </div>
    </Fade>
  );
}

export default Loader;
